import { ColumnModel, TableModel } from "gaming-component-ngx-common";
import {IReportData} from "./report-data-interface";
import * as moment from "moment";
import * as momentTz from 'moment-timezone';

export class BreachDetailsData {
    public gmid: string;
    public serial: string;
    public dateDetectedStart: moment.Moment;
    public dateDetectedEnd: moment.Moment;
    public durationHours: string;
    public turnOver: number;
    public gamesPlayed: number;
    public dateNonTradingPrevStart: moment.Moment;
    public dateNonTradingPrevEnd: moment.Moment;
    public dateNonTradingNextStart: moment.Moment;
    public dateNonTradingNextEnd: moment.Moment;
    public dateShutdownStart: moment.Moment;
    public dateShutdownEnd: moment.Moment;

    get dateDetectedStartText(): string {
        if (this.dateDetectedStart === undefined) { return undefined; }
        return this.cvtz(this.dateDetectedStart).format('DD/MM/YYYY h:mmA');
    }

    get dateDetectedEndText(): string {
        if (this.dateDetectedEnd === undefined) { return undefined; }
        return this.cvtz(this.dateDetectedEnd).format('DD/MM/YYYY h:mmA');
    }

    get durationHoursText(): string {
        if (this.durationHours === undefined) { return undefined; }
        let suffix = 'hour';  if (this.durationHours != '1') { suffix += 's'; }
        return `${this.durationHours} ${suffix}`;
    }

    get turnOverDollars(): number {
        if (this.turnOver === undefined) { return undefined; }
        return this.turnOver / 100;
    }

    private cvtz(date: any): any {
        return momentTz(date).tz('Australia/Sydney');
    }
}

export class EntityDetailsData implements IReportData {
    public venue: string;
    public venueLiquorLicenceNumber: string;
    public venueType: string;
    public licenceStartDate: moment.Moment;
    public licenseeName: string;
    public telephone: string;
    public licenceStatus: string;
    public email: string;
    public address: string;
    public timeZone: string;

    public tableData: TableModel;

    constructor() {
        this.tableData = new TableModel();
        this.tableData.columns = new Array<ColumnModel>();
        this.tableData.allRows = new Array<BreachDetailsData>();
        this.setColumns();
    }

    public setColumns() {
        this.tableData.columns.push(new ColumnModel("gmid", "gmid", "GMID", true, "", null, null, null));
        this.tableData.columns.push(new ColumnModel("serial", "serial", "Serial Number", true, "", null, null));
        this.tableData.columns.push(new ColumnModel("dateDetectedStartText", "dateDetectedStartText", "Play Detected From", true, "", null, null));
        this.tableData.columns.push(new ColumnModel("dateDetectedEndText", "dateDetectedEndText", "Play Detected To", true, "", null, null));
        this.tableData.columns.push(new ColumnModel("durationHours", "durationHours", "Duration", true, "", null, null));
        this.tableData.columns.push(new ColumnModel("turnOverDollars", "turnOverDollars", "Turnover ($)", true, "", null, "numeric"));
        this.tableData.columns.push(new ColumnModel("gamesPlayed", "gamesPlayed", "Games Played", true, "", null, "numeric"));
        // default sorting
        this.tableData.columns[3].isSortSelected = true;
        this.tableData.columns[3].sortDirection = "descending";
        this.tableData.secondarySortColumn = "dateDetectedEndText";
        this.tableData.secondarySortDirection = "descending";
        this.tableData.secondarySortType = null;
    }

    get licenceStartDateText(): string {
        if (this.licenceStartDate === undefined) { return undefined; }
        let timeZoneMinutes = (this.licenceStartDate as any)._tzm;
        let utcTime = this.licenceStartDate.clone().utc().add(timeZoneMinutes, "minutes");
        return utcTime.format("DD MMM YYYY");
    }

    get nonTradingHours(): string {
        let rv = undefined;
        if (this.tableData && this.tableData.allRows.length > 0) {
            const bd: BreachDetailsData = this.tableData.allRows[0];
            if (bd.dateNonTradingPrevStart && bd.dateNonTradingPrevEnd) {
                rv = '' + this.cvtz(bd.dateNonTradingPrevStart).format('h:mmA') + ' to ' + this.cvtz(bd.dateNonTradingPrevEnd).format('h:mmA');
                if (bd.dateNonTradingNextStart && bd.dateNonTradingNextEnd) {
                    rv = rv + ' and ' + this.cvtz(bd.dateNonTradingNextStart).format('h:mmA') + ' to ' + this.cvtz(bd.dateNonTradingNextEnd).format('h:mmA');
                }
            }
        }
        return rv;
    }

    get shutdownHours(): string {
        let rv = undefined;
        if (this.tableData && this.tableData.allRows.length > 0) {
            const bd: BreachDetailsData = this.tableData.allRows[0];
            if (bd.dateShutdownStart && bd.dateShutdownEnd) {
                rv = '' + this.cvtz(bd.dateShutdownStart).format('h:mmA') + ' to ' + this.cvtz(bd.dateShutdownEnd).format('h:mmA');
            }
        }
        return rv;
    }

    private cvtz(date: any): any {
        return momentTz(date).tz('Australia/Sydney');
    }

    public toCSV() {
        this.tableData.csvHeader = this.generateCsvHeader();
        return this.tableData.toCSV();
    }

    public generateCsvHeader() {
      const address = this.address.replace(/\,/g, '');
      let header = `Licence Number,Licence Name,Timestamp,Licence Type,Start Date,Status Change Date,Licensee Name,Contact Number,Licence Status,Email,Address,Timezone\n`;
      header += `${this.venueLiquorLicenceNumber || '-'},`;
      header += `${this.venue || '-'},`;
      header += `${momentTz().tz("Australia/Sydney").format("DD/MM/YYYY h:mmA")},`;
      header += `${this.venueType || '-'},`;
      header += `${this.licenceStartDateText || '-'},`;
      header += `${this.licenceStartDateText || '-'},`;
      header += `${this.licenseeName || '-'},`;
      header += `${this.telephone || '-'},`;
      header += `${this.licenceStatus || '-'},`;
      header += `${this.email || '-'},`;
      header += `${address|| '-'},`;
      header += `${this.timeZone || '-'}`;
      header += `\n`;
      return header;
    }
}



// WEBPACK FOOTER //
// ./client/app/models/breach-details-model.ts